import { useTheme } from 'next-themes';
import Image from 'next/image';

const AS_REGEX = /\(as\)|\(asws\)|\(AS\)|\(A\.S\)|\(a\.s\.\)|\(a\)|\(a\.s\)/;
const SW_REGEX =
  /\(sw\)|\(sws\)|\(SA\)|\(SW\)|\(S\.W\)|\(s\.w\)|\(s\.w\.\)|\(saw\)|\(SAW\)|\(saww\)|\(s\.a\.w\)|\(s\.a\.w.\)|\(s\.a\.a\.w\.\)/;
const RA_REGEX = /\(ra\)|\(ras\)|\(RA\)|\(R\.A\)/;

function displayText(text: string, dark?: boolean) {
  return text
    .split(RegExp('(' + AS_REGEX.source + '|' + SW_REGEX.source + '|' + RA_REGEX.source + ')'))
    .map((el, i) => {
      if (el.match(RegExp(AS_REGEX.source))) {
        return (
          <Image key={i} alt="(a.s)" className="inline dark:invert grayscale" height={25} src="/as.svg" width={25} />
        );
      } else if (el.match(RegExp(SW_REGEX))) {
        return 'ﷺ';
      } else if (el.match(RegExp(RA_REGEX))) {
        return (
          <span key={i} className={`inline dark:invert grayscale`}>
            <Image key={i} alt="(r.a)" className="inline" height={20} src="/ra.png" width={20} />
          </span>
        );
      } else {
        return el;
      }
    });
}

export default function TextWithHonorifics({ text, startingIndex }: { text: String; startingIndex?: number }) {
  let narrators = '';
  let narration = '';

  const { resolvedTheme } = useTheme();
  const dark = resolvedTheme === 'dark';

  if (text && startingIndex && startingIndex > 5) {
    if (['"', "'", '“'].includes(text.slice(startingIndex - 1, startingIndex))) {
      startingIndex = startingIndex - 1;
    }

    narrators = String(text).slice(0, startingIndex);
    narration = String(text).slice(startingIndex);

    return (
      <>
        <span className="text-slate-400">{narrators && displayText(narrators, dark)}</span>
        {narration &&
          narration.split('<br>').map((el, i) => (
            <span key={el} className="inline">
              {i != 0 && <br />}
              {i != 0 && <br />}
              {displayText(el, dark)}
            </span>
          ))}
      </>
    );
  }

  return <>{text && displayText(String(text), dark)}</>;
}
